
enum NativeSources {
  Alloc8or = 'alloc8or',
  FiveM = 'fivem',
  DottieDot = 'dottiedot',
  SpecialData = 'special'
}
export default NativeSources
